<template>
	<template v-for="(listing, listingIndex) in passedListingsData" :key="'l-' + listingIndex">
		<ListingRow
			:passed-listing="listing"
			:passed-seller="passedSeller"
			:passed-seller-index="passedSellerIndex"
			:passed-condition="passedCondition"
			:passed-condition-index="passedConditionIndex"
			:passed-listings-index="listingIndex"
			:passed-market-data="passedMarketData"
			:passed-mm-data="passedMmData"
			:passed-total-row-span="passedTotalRowSpan"
			:passed-total-seller-row-span="passedTotalSellerRowSpan"
			:passed-market-index="passedMarketIndex"
			:passed-asin="passedAsin"
			:passed-ean="passedEan"

		/>
	</template>

	<template v-for="(command, commandIndex) in passedCommandData?.commands" :key="'c-' + commandIndex">
		<CommandRow
		:passed-command="command"
		:passed-seller="passedSeller"
		:passed-seller-index="passedSellerIndex"
		:passed-condition="passedCondition"
		:passed-condition-index="passedConditionIndex"
		:passed-command-index="commandIndex"
		:passed-market-data="passedMarketData"
		:passed-mm-data="passedMmData"
		:passed-total-row-span="passedTotalRowSpan"
		:passed-total-seller-row-span="passedTotalSellerRowSpan"
		:no-listings="!passedListingsData"
		:passed-market-index="passedMarketIndex"
		:passed-asin="passedAsin"
		:passed-ean="passedEan"
		/>
	</template>

	<template v-for="(priceStarInfo, priceStarInfoIndex) in passedPriceStarData" :key="'c-' + commandIndex">
		<PriceStarInfo
				:passed-price-star-info="priceStarInfo"
				:passed-seller="passedSeller"
				:passed-seller-index="passedSellerIndex"
				:passed-condition="passedCondition"
				:passed-condition-index="passedConditionIndex"
				:passed-price-star-info-index="priceStarInfoIndex"
				:passed-market-data="passedMarketData"
				:passed-mm-data="passedMmData"
				:passed-total-row-span="passedTotalRowSpan"
				:passed-total-seller-row-span="passedTotalSellerRowSpan"
				:no-listings="!passedListingsData"
				:passed-market-index="passedMarketIndex"
				:passed-asin="passedAsin"
				:passed-ean="passedEan"
		/>
	</template>
</template>

<script>

import ListingRow from "./ListingRow.vue";
import CommandRow from "./CommandRow.vue";
import PriceStarInfo from "./PriceStarInfoRow.vue";

export default {
	components: {CommandRow, ListingRow, PriceStarInfo},
	props: {
		passedSeller: {
			type: String,
			required: true,
		},
		passedSellerIndex: {
			type: Number,
			required: true,
		},
		passedCondition: {
			type: String,
			required: true,
		},
		passedConditionIndex: {
			type: Number,
			required: true,
		},
		passedListingsData: {
			type: Object,
			required: true,
		},
		passedCommandData: {
			type: Object,
		},
		passedPriceStarData: {
			type: Object,
		},
		passedMarketData: {
			type: Object,
			required: true,
		},
		passedMmData: {
			type: Object,
		},
		passedTotalRowSpan: {
			type: Number,
			required: true,
		},
		passedTotalSellerRowSpan: {
			type: Number,
			required: true,
		},
		passedMarketIndex: {
			type: Number,
			required: true,
		},
		passedAsin: {
			type: String,
			required: true,
		},
		passedEan: {
			type: String,
			required: true,
		}
	},
	data() {
		return {
		totalRowSpan: 0,
		};
	},
	methods: {


	}
}
</script>
<style scoped>
.market-cell {
	text-align: center;
	vertical-align: middle;
	font-weight: bold;
	border-right: 2px solid #ddd;
}
.vert-align{
	vertical-align: middle
}
</style>